import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const shortLandscape = '@media (orientation: landscape) and (max-height: 600px)';

export const useStyles = makeStyles(({ breakpoints, fontWeights }: Theme) => ({
  paper: {
    '&&': {
      width: '99vw',
      maxWidth: '66rem',
      height: 'auto',
      maxHeight: '99vh',
      borderRadius: '1rem',
      paddingTop: '0.625rem',
      paddingBottom: '0.625rem',
      overflowY: 'unset',
      [breakpoints.up('md')]: {
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
      [shortLandscape]: {
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
      },
    },
  },
  title: {
    fontSize: '1.125rem',
    lineHeight: 1.4,
    margin: 0,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    [breakpoints.up('md')]: {
      gap: '1.5rem',
    },
    '&&': {
      paddingLeft: '0.625rem',
      paddingRight: '0.625rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  frame: {
    width: '100%',
    height: 'auto',
    border: 'none',
  },
  frameLandscape: {
    aspectRatio: '16 / 9',
    width: 'min(100%, calc((100vh - 6.5rem) * 16 / 9))',
    maxHeight: 'calc(100vh - 6.5rem)',
  },
  framePortrait: {
    aspectRatio: '9 / 16',
    width: 'min(100%, calc((100vh - 5rem) * 9 / 16))',
    maxHeight: 'calc(100vh - 5rem)',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    lineHeight: 0,
  },
}));
